/**
 * Download Excel exports from the API.
 */

function buildQuery(params: Record<string, string | undefined>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) search.append(key, value);
  });
  const q = search.toString();
  return q ? `?${q}` : '';
}

async function downloadExcel(path: string, filename: string): Promise<void> {
  const token = localStorage.getItem('token');
  const response = await fetch(`/api/v1/export${path}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error((err as { message?: string }).message || 'Export failed');
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export async function downloadUsersExcel(
  filters: { search?: string; role?: string; status?: string; department_id?: string } = {}
): Promise<void> {
  return downloadMembersExcel(filters);
}

export async function downloadMembersExcel(
  filters: { search?: string; role?: string; status?: string; department_id?: string } = {}
): Promise<void> {
  const query = buildQuery(filters);
  await downloadExcel(`/users/xlsx${query}`, `members-${new Date().toISOString().split('T')[0]}.xlsx`);
}

export async function downloadComplaintsExcel(
  filters: { status?: string; priority?: string; search?: string; department_id?: string } = {}
): Promise<void> {
  const query = buildQuery(filters);
  await downloadExcel(`/complaints/xlsx${query}`, `complaints-${new Date().toISOString().split('T')[0]}.xlsx`);
}

export async function downloadComplaintReportExcel(
  filters: Record<string, string | undefined> = {}
): Promise<void> {
  const query = buildQuery(filters);
  await downloadExcel(`/reports/complaints/xlsx${query}`, `complaint-report-${new Date().toISOString().split('T')[0]}.xlsx`);
}

export async function downloadMemberReportExcel(
  filters: Record<string, string | undefined> = {}
): Promise<void> {
  const query = buildQuery(filters);
  await downloadExcel(`/reports/users/xlsx${query}`, `member-report-${new Date().toISOString().split('T')[0]}.xlsx`);
}
